import { createFileRoute } from '@tanstack/react-router'
import { CreateVaccinePage } from '_/features/pets/ui/pages/create-vaccine-page'

const CreateVaccineRoute = () => {
	const { petId } = Route.useParams()
	return <CreateVaccinePage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/vaccines/create')({
	staticData: { title: 'vaccines_create_title' },
	component: CreateVaccineRoute,
})
